/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon16Regular = forwardRef('ArrowDim1HIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.03 3.97a.75.75 0 0 1 0 1.06L2.811 7.25h10.378l-2.22-2.22a.75.75 0 1 1 1.061-1.06l2.793 2.793a1.75 1.75 0 0 1 0 2.474L12.03 12.03a.75.75 0 0 1-1.06-1.06l2.22-2.22H2.81l2.22 2.22a.75.75 0 1 1-1.06 1.06L1.177 9.237a1.75 1.75 0 0 1 0-2.474L3.97 3.97a.75.75 0 0 1 1.06 0Z" })));
});
